<div class="new_player" *ngIf="firstScreen === true">
  <input #newPlayerName placeholder="New Player"/>
  <button (click)="playerservice.addPlayer(newPlayerName.value); newPlayerName.value=''"> + </button>
</div>
<div class="players" [class.playing]="firstScreen === 'playarea'" >
  <div class="player" *ngFor="let player of playerservice.players" [style.animationDuration]="player.duration">
    <span
    class="keycode" [style.backgroundColor]="player.color" >{{ player.keyCode}}</span>
    <span class="name">{{ player.name }}</span>
    <span class="score" *ngIf="firstScreen !== true">{{ player.score }}</span>

  </div>
﻿</div>
<h3 *ngIf="firstScreen === true">*Score 500 first to win the game</h3>
<a class='start_game' href='/project/dribbler/play' *ngIf=" firstScreen === true " >
Start the game
</a>



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/players/players.component.html